import Footer from "../Footer";
import HeaderInfoBar from "../HeaderInfoBar";
import HealthHeader from "../HealthHeader";
import { ScrollToHash } from "../ScrollToHash";

export const WebsiteLayout = ({ className, children }) => {
  return (
    <div>
      <ScrollToHash />
      <HeaderInfoBar />
      <HealthHeader />
      <div className={`mx-auto  h-full ${className}`}>{children}</div>
      <Footer />
    </div>
  );
};
